export default __webpack_public_path__ + "static/media/you-can-do-it-480w.0434f25c.webp";